import React, {useState} from 'react'

//import React, {useEffect, useState} from 'react'
// 2/28/2025: This block of code has been commented out because I'm having issues getting my backend to work on EC2 (403 Errors)
// The front end works fine so I'm modifying the code to pull from a static array instead of fetching data
// function Projects(){
//     const [projects, setProjects] = useState([]);
//     const [selectedProject, setSelectedProject] = useState(null);
//       useEffect(() => {
//         // fetch(`http://localhost:8080/projects/${id}`)
//         // fetch("https://18.116.167.241:8080/projects")
//           fetch("http://localhost:8080/projects")
//               .then((response) => response.json())
//               .then((data=>setProjects(data)))
//               .catch((error) => console.error("Error fetching projects: ", error));
//       }, []);
//       const handleButtonClick = (id) => {
//         // Have to use `, aka a backtick instead of '/" for the fetch url
//         // fetch(`http://localhost:8080/projects/${id}`)
//         //fetch(`https://18.116.167.241:8080/projects/${id}`)
//         fetch(`http://localhost:8080/projects/${id}`)
//         .then((response)=> response.json())
//         .then((data) => setSelectedProject(data))
//         .catch((error) => console.error("Error fetching project: ", error));
//     };
//        return(
//     <section id = "projects">
//     <h2>Projects</h2>
//     <div>
//         {projects.map((project) => (
//             <button
//                 key={project.id} 
//                 onClick={() => handleButtonClick(project.id)}
//                 style={{margin: "0.5rem",padding: "0.5rem 1rem"}}
//             >
//                 {project.projectName}
//             </button>
//         ))}
//     </div>
//     {selectedProject && (
//         <div style={{ marginTop: "1rem", padding: "1rem", border: "2px solid #ccc"}} >
//             <h3> {selectedProject.projectName}</h3>
//             <p> {selectedProject.description}</p>
//         </div>
//     )}
// </section>
// );
// }
function Projects(){
    const projectList = [
        {id: 1, projectName: "Personal Website", description: "Created a personal website using React CSS and Spring Boot.\n Hosted the website using AWS." }
    ];
        const [selectedProject, setSelectedProject] = useState(null);
        const handleButtonClick = (project) => {
            setSelectedProject((prevProject) => (prevProject?.id === project.id ? null : project));
        };
    
        return(
            <section id = "projects">
                <h2>Projects</h2>
                <div>
                    {projectList.map((project) => (
                        <button
                            key={project.id} 
                            onClick={() => handleButtonClick(project)}
                            style={{margin: "0.5rem",
                                padding: "0.75rem 1.5rem",
                                backgroundColor: selectedProject?.id === project.id ? "#f4dfce" : "transparent",
                                fontSize: "1rem",
                                cursor: "pointer"}}
                        >   
                            {project.projectName}
                        </button>
                    ))}
                </div>
                <div className={`content-wrapper ${selectedProject ? "open" : ""}`}>
                {selectedProject && (
                    <div className="content">
                        <h3>{selectedProject.projectName}</h3>
                        <p> {selectedProject.description}</p>
                    </div>
                )}
                </div>
            </section>
        );
}

export default Projects;